import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldTask']),
        getByProject: (state) => idProject => {
            return state.objs.filter(task => task.project === idProject);
        },
        getByUser: state => idUser => {
            return state.objs.filter(task => task.users.includes(idUser));
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldTask']),
        deleteByProject: (state, idProject) => {
            state.objs.forEach((task, index) => {
                if(task.project === idProject){
                    state.objs.splice(index, 1);
                }
            });
        }
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldTask']),
        deleteByProject: ({ commit }, idProject) => {
            return new Promise(resolve => {
                commit('deleteByProject', idProject);
                resolve();
            });
        }
    }
}